import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useLanguage } from '../../contexts/LanguageContext';

const EventDescription = ({ event, language: languageProp }) => {
  const { t, language: contextLanguage } = useLanguage();
  const language = languageProp || contextLanguage;

  const description = language === 'th'
    ? (event.description_th || event.description_en || '')
    : (event.description_en || event.description_th || '');

  if (!description) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        {t('events.description')}
      </h2>
      <div className="prose prose-lg max-w-none">
        <ReactMarkdown>{description}</ReactMarkdown>
      </div>
    </div>
  );
};

export default EventDescription;
